// extracted by mini-css-extract-plugin
module.exports = {"container":"staticMap_container__2J91t","map":"staticMap_map__2pJKK"};